import { ReactElement } from 'react'
import { UnitField, type UnitFieldProps } from '../UnitField'

export type CentimeterFieldProps<F> = Omit<
  UnitFieldProps<F>,
  'internalUnit' | 'displayUnit' | 'numeralFormatter'
> & {
  /** Allow up to two decimal places in cm (default one optional decimal). */
  twoDecimalPlaces?: boolean
  hideFormControl?: boolean
  hideAdornment?: boolean
  formControlFullWidth?: boolean
}

const CentimeterField = <F,>({
  sx,
  twoDecimalPlaces = false,
  hideFormControl,
  hideAdornment,
  formControlFullWidth,
  ...textFieldProps
}: CentimeterFieldProps<F>): ReactElement => {
  return (
    <UnitField
      {...textFieldProps}
      hideFormControl={hideFormControl}
      hideAdornment={hideAdornment}
      formControlFullWidth={formControlFullWidth}
      internalUnit="m"
      displayUnit="cm"
      numeralFormatter={twoDecimalPlaces ? '0.[00]' : '0.[0]'}
      sx={{
        width: 'fit-content',
        ...sx,
      }}
    />
  )
}

export default CentimeterField
